import type { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const isV3enabled = (flowAPI: ControllerFlowAPI) => {
  return flowAPI.experiments.enabled('specs.programs.OOINileMigration');
};
